<template lang="pug">
md-layout.qortex-container
  .md-headline Qortex
  div
    md-switch(v-model="localNonLinearEnabled")
    md-button.md-primary.md-raised(@click="openQortexDialog" :disabled="!localNonLinearEnabled") Set Qortex
  md-dialog#general-form-wrapper(:md-click-outside-to-close='false', :ref='dialogRef')
    md-dialog-title Qortex
    md-dialog-content(v-if="openDialog")
      md-input-container
        label Group ID
        md-input(v-model="localQortexData.groupId")
      md-input-container
        label Bundle ID
        md-input(v-model="localQortexData.bundleId")
      md-input-container
        label Marketplace ID
        md-input(v-model="localQortexData.marketplaceId")
      md-input-container
        label Store ID
        md-input(v-model="localQortexData.storeId")
      div.btn-container
          md-button.md-primary.md-raised(@click='saveQortexData()') Save
          md-button.cancel-btn.md-raised(@click='closeDialog()') Cancel
</template>

<script>
export default {
  props: {
    qortexData: {
      type: Object,
      default: () => ({
        groupId: "",
        bundleId: "",
        marketplaceId: "",
        storeId: ""
      })
    },
    nonLinearEnabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      openDialog: false,
      dialogRef: 'qortexDialog',
      localQortexData: { ...this.qortexData },
      localNonLinearEnabled: this.nonLinearEnabled
    };
  },
  methods: {
    openQortexDialog() {
      this.openDialog = true;
      this.$refs[this.dialogRef].open();
    },
    closeQortexDialog() {
      this.openDialog = false;
      this.$refs[this.dialogRef].close();
    },
    saveQortexData() {
      this.$emit('qortex-updated', this.localQortexData);
      this.$emit('non-linear-updated', this.localNonLinearEnabled);
      this.closeQortexDialog();
    },
    closeDialog() {
      this.$emit('cancel-dialog');
      this.closeQortexDialog();
    }
  },
  watch: {
    nonLinearEnabled(newVal) {
      this.localNonLinearEnabled = newVal;
    },
    qortexData(newVal) {
      this.localQortexData = { ...newVal };
    },
    localNonLinearEnabled(newVal) {
      this.$emit('non-linear-updated', newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.qortex-container {
  display: flex;
  margin-bottom: 30px !important;
  align-items: center;
  justify-content: space-between;
}
.md-headline {
  margin: 0px;
}

.cancel-btn {
    background-color: #d33 !important;
    color: white !important;
    font-size: 1.1em;
}

.cancel-btn :hover {
    background-color: #d33 !important;
}

.btn-container {
    display: flex;
    justify-content: end;
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/QortexForm.vue